<template>
    <div class="login">
        <form class="dialog-form" id="my_form">
            <input type="text" placeholder="用户名" v-model="userName">
            <input type="password" placeholder="密码" v-model="password">
            <div class="geet-content">
                <div id="embed-captcha"></div>
                <p id="wait" class="show">正在加载验证码......</p>
                <p id="notice" class="hide">请先拖动验证码到相应位置</p>
                <br/>
            </div>
            <div class="btn-login">
                <el-button type="primary" @click.prevent="loginEvent">登 录</el-button>
            </div>
        </form>
    </div>
</template>

<script>
/* eslint-disable */
import { get, post } from '@/api/index'
import { mapState, mapActions } from 'vuex'
import jquery from '@/assets/js/jquery-3.3.1.min.js'
import jqueryForm from '@/assets/js/jquery.form.min.js'

export default {
    data() {
        return {
            userName: '',
            password: '',
            validateDate: {}
        }
    },
    inject: ['reload'],
    created() {
        this.$store.commit('setUserPromistion', null)
    },
    mounted() {
        this.initGeet();
    },
    methods: {
        // 获取极验数据
        initGeet() {
            let url = this.$baseUrl+'/geettest/captcha';
            get(url).then((resp) => {
                if (resp.code === 200) {
                    var data = resp.data;
                    this.validateDate = data;
                    initGeetest({
                        gt: data.gt,
                        challenge: data.challenge,
                        product: "embed",
                        offline: !data.success
                        , new_captcha: data.new_captcha,
                        api_server: "api.geetest.com"
                    }, this.handlerEmbed);
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: '获取验证码失败',
                        offset: 100
                    })
                }
            }).catch(e => {
                this.$notify.error({
                    title: '错误',
                    message: e,
                    offset: 100
                })
            })
        },

        // 极验处理函数
        handlerEmbed(captchaObj) {
            $("#embed-submit").click(function (e) {
                var validate = captchaObj.getValidate();
                if (!validate) {
                    $("#notice")[0].className = "show";
                    setTimeout(function () {
                        $("#notice")[0].className = "hide";
                    }, 2000);
                    e.preventDefault();
                }
            });
            //  弹出层
            captchaObj.appendTo("#embed-captcha");
            //  弹出层指定触发事件
            captchaObj.onReady(function () {
                $("#wait")[0].className = "hide";
            });

            // captchaObj.onClose(() => {
            //     captchaObj.destroy();
            // })
        }, 

        // 登录
        loginEvent() {
            var queryString = $('#my_form').serializeArray();
            var param = {};
            queryString.map(value => {
                param[value.name] = value.value;
            });
            param['userId'] = this.validateDate.user_id;
            param['username'] = this.userName;
            param['password'] = this.password;
            post(this.$baseUrl+'/user/login', JSON.stringify(param)).then((resp) => {
                if (resp.code === 200) {
                    this.$cookies.set('token', resp.data.token, '2D');
                    this.$cookies.set('userName',   this.userName, '2D');
                    this.$cookies.set('isSuper', resp.data.is_super, '2D');
                    
                    sessionStorage.setItem('isSuper', resp.data.is_super);
                    sessionStorage.setItem('token', resp.data.token);
                    sessionStorage.setItem('userName', this.userName);
                    this.$store.commit('getToken', resp.data.token);
                    this.$store.commit('getUserName', this.userName);
                    this.$store.commit('setUnilateralLevel', resp.data.is_super);

                    if (this.$route.path == '/login' || this.$route.path == '/') {
                        
                        if (resp.data.is_super == '0') {
                            this.$router.push('/user');
                        } else if (resp.data.is_super == '1') {
                            this.$router.push('/market');
                        }
                    } else {
                        this.reload();
                    }
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: resp.info,
                        offset: 100
                    })

                    // 刷新页面
                    this.reload();
                }
            }).catch(error => {
                this.$notify.error({
                    title: '错误',
                    message: error,
                    offset: 100
                })
            })
        },
    }
}
</script>

<style lang="scss">
.login{
    padding: 20px 0;
    .dialog-form{
        width: 80%;
        margin: 0 auto;
        .geet-content{
            display: inline-block;
            width: 96%;
            #embed-captcha{
                width: 100% !important;
                border: 0;
                .geetest_holder{
                    width: 100% !important;
                    min-width: 0;
                    border: 0;
                }
            }
        }
        input{
            border-radius: 5px;
            border: 0px solid #000;
            height: 40px;
            outline: none;
            width: 94%;
            margin-bottom: 10px;
            padding: 0 1%;
            padding-left: 5px;
            background-color: #000 !important;
            color: #807c7c;
        }
    
        // 利用动画延迟
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus, 
        input:-webkit-autofill:active {
            transition-delay: 99999s;
            transition: color 99999s ease-out, background-color 99999s ease-out;
            -webkit-transition-delay: 99999s;
            -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
            -webkit-text-fill-color: #807c7c;
        }

        .el-input{
            padding: 5px;
            .el-input__inner{
                background-color: #1e1e1e !important;
                border-color: #1e1e1e !important;
            }
            .el-input__inner:focus{
                color: #fff;
            }
        }
        .btn-login{
            padding: 5px;
            display: inline-block;
            width: 96%;
            .el-button{
                width: 100%;
                background-color: #eb602e;
                border-color: #eb602e;
            }
            .el-button:hover{
                background-color: #8c3c1f;
            }
        }
        .notice{
            color: #807c7c;
            font-size: 13px;
            text-align: right;
            padding: 5px 0;
            a:hover{
                cursor: pointer;
                color: #fff;
            }
        }
    }
    .show{
        display: block;
    }
    .hide{
        display: none;
    }
}
</style>
